var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountSettingWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 1.23a.8.8 0 01.8 0l5.262 3.04a.8.8 0 01.4.692v6.076a.8.8 0 01-.4.693L8.4 14.769a.8.8 0 01-.8 0l-5.262-3.038a.8.8 0 01-.4-.693V4.962a.8.8 0 01.4-.693L7.6 1.231z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 2,
    stroke: "#fff",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/account_setting_white.acbd8028.svg";
export { SvgAccountSettingWhite as ReactComponent };